export enum Methods {
    GetAccessToken = 'getAccessToken',
    RequestInAppPurchase = 'requestInAppPurchase',
}

export function getSemrushSDK(): SemrushSDK {
    return window.SM;
}
